import { Component, inject, output } from '@angular/core';
import { BottomTableComponent } from '@shared/components/bottom-table/bottom-table.component';
import { ProgramTargetService } from '../../services/program-target.service';
import { BaseDatasource } from '@shared/base/base.datasource';
import { IProgramTarget } from '../../interfaces/tab-program-target.interface';

@Component({
  selector: 'app-program-target-pagination',
  standalone: true,
  imports: [BottomTableComponent],
  templateUrl: './program-target-pagination.component.html',
  styleUrl: './program-target-pagination.component.scss',
})
export class ProgramTargetPaginationComponent {
  readonly service = inject(ProgramTargetService);
  dataSource = this.service.dataSource;

  readonly pageChange = output<BaseDatasource<IProgramTarget>>();

  handlePageChange(event: BaseDatasource<IProgramTarget>): void {
    this.pageChange.emit(event);
  }
}
